// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v9te","left":"styles_left__117HW"};